<template>
  <div class="buttons">
    <div class="button" v-for="tech in technologies" :key="tech.name">
      <label :for="`btn-${tech.name}`" style="display: none">Select technology {{tech.name}}</label>
      <button :id="`btn-${tech.name}`" class="button__btn" @click.prevent="makeActive(tech)" :class="{ active: isActive(tech) }">{{tech.name}}</button>
      <span class="button__tooltip">{{tech.tooltip || tech.name}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEqual } from 'lodash';

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters('map', ['technology', 'technologies', 'network'])
  },
  methods: {
    makeActive(tech) {
      this.$emit('select', tech);
    },

    isActive(tech) {
      return isEqual(this.technology, tech);
    }
  },
  watch: {
    network() {
      this.$emit('select', this.technologies[0]);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import 'nib'

$bSize = 46px

$tooltip = 40px

.buttons
  display grid
  grid-template-columns repeat( auto-fit, minmax($bSize * 1.5, 1fr) )

.button
  notSelectable()
  display flex
  flex-direction column
  align-items center
  &__btn
    clickable()
    column()
    justify-content center
    align-items center
    height $bSize
    min-height $bSize
    min-width $bSize
    width: stretch
    max-width $bSize * 2
    background white
    border none
    border-bottom 2px solid #018478
    color #018478
    font-size $bSize * 0.5
    font-weight normal
    margin 12px
    text-transform uppercase
    padding "calc((%s - %s * 0.86) / 2)" % ($bSize $bSize) !important
    transition 0.3s all ease-in-out
    font-family "Open Sans", sans-serif
    font-weight 400
    &:active
      outline none
      position static !important
    &.active
      border none
      min-height $bSize * 1.2
      height $bSize * 1.2
      margin 8px
      background #018478
      color white
      box-shadow 1px 1px 2px rgba(0,0,0, 0.16)
  &__tooltip
    row()
    justify-content center
    align-items center
    font-size 12px
    color white
    visibility hidden
    white-space nowrap
    max-width 100%
    text-overflow ellipsis
    overflow hidden
    background #666666
    padding 10px
    height $tooltip
    box-sizing border-box
    width 100%
    absolute bottom (-1 * $tooltip) left 0
    transition visibility 0.1s ease-in-out 0.2s, opacity 0.3s ease-in-out 0.1s
    z-index 20
    opacity 0
  &:hover &__tooltip
    visibility visible
    opacity 1

</style>
